<template>
  <div class="col">
    <div class="col-measurer" ref="measurer">
      <portfolio-image v-for="image in images" 
        :key="image.image_id" :artist="artist" :image="image"
        v-on:click="handleZoom" 
        v-on:loaded="handleLoaded" />
    </div>
  </div>
</template>

<script>
import PortfolioImage from '@/components/widgets/PortfolioImage.vue'

export default {
  components: {
    PortfolioImage
  },
  props: {
    images: Array,
    artist: Object,
    maxheight: Number,
    dists: Array,
    fullyLoaded: Boolean
  },
  data () {
    return {
      loadCount: 0,
      lbottom: 0
    }
  },
  methods: {
    handleZoom(image) {
      this.$emit('click', image)
    },
    async handleLoaded() {
      this.loadCount++;
      if(this.loadCount >= this.images.length) {
        this.updateLbottom()
        if(this.loadCount > 4){
          await this.$k.waitfor(500)
          this.$emit('loaded', this.lbottom)
        }
        
      }
    },
    updateLbottom() {
      if(this.$refs.measurer) {
        let rect = this.$refs.measurer.getBoundingClientRect()
        this.lbottom = rect.bottom + window.scrollY
      }
      
    },
    async addDist() {
      if(this.lbottom < (this.maxheight - 150)) {
        if(this.dists.length > 0) {
          console.log('adding dist', this.dists.length)
          this.images.push(this.dists.pop())
        }
      }
    },
    async checkDists() {
      while(this.dists.length > 0) {
        await this.addDist()
        await this.$k.waitfor(500)
        this.updateLbottom()
      }
    }
  },
  watch: {
    fullyLoaded() {
      if(this.fullyLoaded){
        this.checkDists()
      }
    },
    artist() {
      this.loadCount = 0
      this.lbottom = 0
    }
  }
}
</script>